import React, { useEffect, useState } from 'react'
import { InputLabel , TextField , OutlinedInput ,  IconButton , InputAdornment , Box , FormHelperText } from '@mui/material'
import LoopIcon from '@mui/icons-material/Loop';
import FormikAutocomplete from '../../../shared/AutoCompelete'
import FormikMultiple from '../../../shared/FormikMultiple'
import PrimaryButton from '../../../shared/PrimaryButton';
import CustomButton from '../../../shared/CustomButton';
import LinkButton from '../../../shared/LinkButton';
import MultipleSelect from '../../../shared/multipleSelect';
import {FieldArray } from 'formik'
const styleLabel = {
    color: "#050D2E",
    fontSize: ".875rem",
    fontWeight: "550",
    letterSpacing: "-0.5px",
    lineHeight: "16px",
    marginBottom:"8px",

}
const styleInput = {
    borderRadius: "4px",
    marginBottom:"15px",
    "& .MuiInputBase-root": { 
      height: "37px",
      backgroundColor:"#fff",
    },
    "& .MuiOutlinedInput": { 
      height: "36px",
     },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #DBDEE6",
    },
}

const styleInputPassword = {
  borderRadius: "4px",
  marginBottom:"15px",
  ".MuiOutlinedInput-input":
  {
    backgroundColor:"#fff",

  }
}
const CustomerForm = ({formik,
  NotificationType,
  SendingType,
  Direction,
  saftyType, 
  docType ,
  messageTypes ,
  NotificationTemplates,
  Groups,
  customerType,
  setTouched,
  touched,
  EditMode = false,
  defaultTemplate,
  setDrawer
  }) => {

const [otherAccounts,setOtherAccounts]=useState([])

    const handleChange = (e) => {
       
        formik.handleChange(e);
        setTouched(true)
      };
    
const handleClickShowPassword = () => {
formik.setFieldValue("password",Math.random().toString(36).slice(2))
}

const handleMouseDownPassword = (e) => {
  e.preventDefault();

}

useEffect(() => {
  
  if(formik.values?.otherAccounts?.length > 0)
  {
    setOtherAccounts(formik.values.otherAccounts)
  }
  else {
    setOtherAccounts([])
  }
},[formik.values.otherAccounts])

const handleChangeEmail = (newValue) => {
  if (!touched) setTouched(true);
  
  //const result = newValue.filter(word => word.trim().length > 0);

  formik.setFieldValue("otherAccounts", newValue);
};

function isNumber(evt) {
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
  }
  return true;
}

  return (
   <>
    {!EditMode && <>

      <InputLabel sx={styleLabel}>
               Customer Name
    </InputLabel>
    <TextField
              type="text"
              fullWidth
                sx={styleInput}
                value={formik.values.customerName}
                name="customerName"  
                onChange={handleChange}
                helperText={formik.errors.customerName}
                error={formik.errors.customerName}
              />

      <InputLabel sx={styleLabel}>
               Account No.
    </InputLabel>
    <TextField
             onKeyDown={(e) => isNumber(e)}
              fullWidth
              sx={styleInput}
                value={formik.values.AccountNo}
                name="AccountNo"
                onChange={handleChange}
                helperText={formik.errors.AccountNo}
                error={formik.errors.AccountNo}
              />
                
    
    </>}


    <InputLabel sx={styleLabel}>
         other Accounts (Optional)
    </InputLabel>
    <MultipleSelect
            options={[]}
            width="100%"
           type="text"
            sx={styleInput}
            handleChangeSelection={handleChangeEmail}
            selectedValue={otherAccounts}
            Info="You can add multiple accounts"
          />

     <InputLabel sx={styleLabel}>
       Notification Type
    </InputLabel>
    <FormikAutocomplete 
 options={NotificationType}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.notificationType}
 name="notificationType"
 formik={formik}
 label="Choose Type"
 height={"36px"}
 fullWidthFlag={true}
 validationOn={true}
 setTouched={setTouched}
 touched={touched}
 depends="customerGroup"
/>

{(formik.values.notificationType === "EMAIL" || formik.values.notificationType === "BOTH") &&
<>
<InputLabel sx={styleLabel}>
            Email
    </InputLabel>
    <TextField
              type="Email"
              fullWidth
                sx={styleInput}
                value={formik.values.email}
                name="email"  
                onChange={handleChange}
                helperText={formik.errors.email}
                error={formik.errors.email}
              />

<InputLabel sx={styleLabel}>
            Email CC (Optional)
    </InputLabel>
    <TextField
              type="Email"
              fullWidth
                sx={styleInput}
                value={formik.values.emailcc}
                name="emailcc"  
                onChange={handleChange}
              />

</>
}




{(formik.values.notificationType === "SMS" || formik.values.notificationType === "BOTH") &&
<> 
<InputLabel sx={styleLabel}>
          Phone Number 
    </InputLabel>
    <TextField
              fullWidth
                sx={styleInput}
                value={formik.values.phone}
                name="phone" 
                onChange={handleChange}
                helperText={formik.errors.phone}
                error={formik.errors.phone}
              />

</>}





<InputLabel sx={styleLabel}>
Doc Type For Mail Attachment (Optional)
    </InputLabel>
    <FormikAutocomplete 
 options={docType}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.docType}
 name="docType"
 formik={formik}
 label="Choose Type"
 height={"36px"}
 fullWidthFlag={true}
 validationOn={true}
 setTouched={setTouched}
 touched={touched}
/>

<InputLabel sx={styleLabel}>
Customer Safety (Optional)
    </InputLabel>
    <FormikAutocomplete 
 options={saftyType}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.customerSafty}
 name="customerSafty"
 formik={formik}
 label="Choose Type"
 height={"36px"}
 fullWidthFlag={true}
 setTouched={setTouched}
 touched={touched}
/>

{formik.values.customerSafty === "PROTECTED" && 
<>
<InputLabel sx={styleLabel}>
       Password For Opening Email
    </InputLabel>
    <OutlinedInput
              type="text"
              size='small'
              fullWidth
                sx={styleInputPassword}
                value={formik.values.password}
                name="password"
                onChange={handleChange}
                helperText={formik.errors.password}
                error={formik.errors.password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="GeneratePassword"
                      edge="end"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                       <LoopIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
</>}

<InputLabel sx={styleLabel}>
      Customer Type 
    </InputLabel>
    <FormikAutocomplete 
 options={customerType}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.customerType}
 name="customerType"
 formik={formik}
 label="Choose Type"
 height={"36px"}
 fullWidthFlag={true}
 validationOn={true}
 setTouched={setTouched}
 touched={touched}
 error={formik.errors.customerType}
helperText={formik.errors.customerType}
/>


{formik.values?.customerType === customerType[0] &&
<>

<FieldArray name="MT">
 
 {({ insert, remove, push }) => (
             <Box >
               {formik.values.MT.length > 0 &&
                 formik.values.MT.map((friend, index) => (
      <Box  sx={{backgroundColor:"#d4d6dd2e",padding:"20px",borderRadius:"8px"}} mb={2}  key={index}>
<InputLabel sx={styleLabel}>
Message Type
   </InputLabel>
  <FormikAutocomplete
   options={messageTypes}
   isOptionEqualToValue ={ (option, value) => option.id === value.id}
   getOptionLabel={(option) => option.name}
   value={formik.values.MT[index]?.messageNumber}
   name={`MT.${index}.messageNumber`}
   formik={formik}
   label="Choose Type"
   height={"36px"}
   setTouched={setTouched}
   touched={touched}
  fullWidthFlag={true}
  />
  <FormHelperText sx={{ color: "#d32f2f",marginTop: "-11px",marginBottom: "15px"  
}}>
            {Boolean(formik.errors.MT) && formik.errors?.MT[index]?.messageNumber}
      </FormHelperText>

<InputLabel sx={styleLabel}>
     Choose Template
   </InputLabel>
   <FormikAutocomplete 
options={NotificationTemplates}
getOptionLabel={(option) => (option.name ? option.name : '')}
value={formik.values.MT[index]?.notificationTemplate}
name={`MT.${index}.notificationTemplate`}
formik={formik}
label="Choose Template"
height={"36px"}
fullWidthFlag={true}
setTouched={setTouched}
touched={touched}
/>

<InputLabel sx={styleLabel}>
Sending Type 
   </InputLabel>
   <FormikAutocomplete 
options={SendingType}
isOptionEqualToValue ={ (option, value) => option === value}
value={formik.values.MT[index]?.sendingType}
name={`MT.${index}.sendingType`}
formik={formik}
label="Choose Type"
height={"36px"}
fullWidthFlag={true}
setTouched={setTouched}
touched={touched}
/>

<InputLabel sx={styleLabel}>
Way
   </InputLabel>
   <FormikAutocomplete 
options={Direction}
isOptionEqualToValue ={ (option, value) => option === value}
value={formik.values.MT[index].direction}
name={`MT.${index}.direction`}
formik={formik}
label="Choose Type"
height={"36px"}
fullWidthFlag={true}
setTouched={setTouched}
touched={touched}
/>
<FormHelperText sx={{ color: "#d32f2f",marginTop: "-11px",marginBottom: "15px"  
}}>
            {Boolean(formik.errors.MT) && formik.errors?.MT[index]?.direction}
      </FormHelperText>

        <PrimaryButton onClick={() => remove(index)} disabled={formik?.values?.MT.length === 1}>Remove</PrimaryButton>

      </Box>
                 ))}
                  <LinkButton
                  sx={{marginBottom:"10px",fontSize:"14px"}}
              color="#007AFF"
              onClick={() => push({
                messageNumber:null,
                sendingType:SendingType[2] || "",
                direction:'',
                notificationTemplate: defaultTemplate || '',})}
               >
                    + Add new MT
            </LinkButton>
            
             </Box>
           )}
       </FieldArray>


</>}

{formik.values?.customerType === customerType[1] && 
<>
<InputLabel sx={styleLabel}>
      Customer Group 
    </InputLabel>
    <FormikMultiple 
 options={[...Groups]}
 isOptionEqualToValue ={ (option, value) => option.id === value.id}
 getOptionLabel={(option) => option.name}
 value={formik.values.customerGroup}
 name="customerGroup"
 formik={formik}
 label="Assign to group"
 height={"36px"}
 fullWidthFlag={true}
 validationOn={true}
 setTouched={setTouched}
 touched={touched}
 error={formik.errors.customerGroup}
helperText={formik.errors.customerGroup}
Info="You can assign multiple groups"
/>
</>}


{EditMode && 

<Box 
display="flex"
justifyContent="flex-end"
alignItems="center"
borderTop="1px solid #DBDEE6"
marginTop={2}
paddingTop={2}
>
<Box
display="flex"
gap={2}
>
<div>
<PrimaryButton onClick={() => setDrawer()} >Cancel</PrimaryButton>
 
</div>
<div>
<CustomButton text="Save"  action={() =>formik.handleSubmit()} type="update" disabled={!touched}/>


</div>
</Box>

</Box> 
}
              
   </>
  )
}

export default CustomerForm